import { gql } from 'graphql-request';
import { useMutation } from 'react-query';
import { graphqlConfig } from 'services/config/graphqlConfig';

export const useAdminFinishOnboardingInfo = () => {
  const { client } = graphqlConfig();
  const Mutation = useMutation(async ({ userId, courseId }: { userId: number, courseId: number }) => client.request(
    gql`
    mutation AdminFinishOnboardingInfo($courseId: Float!, $userId: Float!) {
      adminFinishOnboardingInfo(courseId: $courseId, userId: $userId) {
        message
      }
    }
    `,
    {
      courseId,
      userId
    }
  ));
  return Mutation;
};
